import { render, staticRenderFns } from "./MoleculeEditionBillingSatellitesModal.vue?vue&type=template&id=f45ab65c"
import script from "./MoleculeEditionBillingSatellitesModal.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingSatellitesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports